import React, { useEffect, useState, useContext } from "react";
import MenuDoctor from "./navDoctor/MenuDoctor";
import PageHeader from "../pageheader/PageHeader";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../material/button/Button";
import * as medicalApi from "../../service/medicalApi";
import ModalUploadFileV2 from "../material/modal/ModalUploadFileV2";
import ModalAddData from "../material/modal/ModalAddData";
import moment from "moment";
import "moment/locale/th";
import { HashLoader } from "react-spinners";
import Pagination from "../pagination/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import styles from "./GuidelineTextEditor.module.css";

import DataTable from "react-data-table-component";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function GuideCheckInspec() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [toggle, setToggle] = useState("document"); // document, guide
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [date, setDate] = useState("");

  const [guideList, setGuideList] = useState([]);
  const [guidePage, setGuidePage] = useState(1);
  const [guideMaxPage, setGuideMaxPage] = useState(1);
  const [openModalAddData, setOpenModalAddData] = useState(false);
  const [guidelineTitle, setGuidelineTitle] = useState("");
  const [guidelineDetail, setGuidelineDetail] = useState("");
  const [showDetail, setShowDetail] = useState(false);

  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
    if (location.state?.type) {
      setToggle(location.state?.type);
    }
  }, []);

  useEffect(() => {
    getDocumentList();
  }, [page]);

  useEffect(() => {
    getGuideline();
  }, [guidePage]);

  useEffect(() => {
    if (toggle === "document") {
      getDocumentList();
    } else if (toggle === "guide") {
      getGuideline();
    }
  }, [toggle]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await medicalApi.getDocument(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setDocumentList(res["data"]["document_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeDocument = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["document_name"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await medicalApi.removeDocument(item["document_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDocumentList([]);
    }
  };

  const addDocument = async (event) => {
    let formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);
    setLoading(true);
    let res = await medicalApi.addDocument(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getGuideline = async () => {
    setLoading(true);
    let res = await medicalApi.getGuideline(guidePage, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setGuideList(res["data"]["guideline_list"]);
        setGuideMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const addGuideline = async (title, detail) => {
    setLoading(true);
    let res = await medicalApi.addGuideline(title, detail);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalAddData(false);
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  const removeGuideline = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"] || "-"} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await medicalApi.removeGuideline(item["guideline_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const columnsDoc = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (page - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
          onClick={() => {
            window.open(item["document_file"]);
          }}
        >
          {item["document_name"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeDocument(item);
            }}
            className="w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  const columnsGuide = [
    {
      name: "ลำดับที่",
      selector: (item, index) => <div>{10 * (guidePage - 1) + 1 + index}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อ",
      selector: (item) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left"
          onClick={() => {
            // console.log(item);
            nav("/guidelineTextEditor", {
              state: {
                type: "view",
                title: item["title"],
                detail: item["detail"],
              },
            });
            // setGuidelineTitle(item['title'])
            // setGuidelineDetail(item['detail'])
            // setShowDetail(true)
            // setOpenModalAddData(true)
          }}
        >
          {item["title"] || "-"}
        </div>
      ),
      wrap: true,
    },
    {
      name: "เพิ่มเติม",
      selector: (item) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              removeGuideline(item);
            }}
            className="w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  return (
    <div className="global-page">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <MenuDoctor menuActive={"guideCheckInspec"} />
      <PageHeader titlename={"แนวทางการตรวจและวรรณกรรมที่เกี่ยวข้อง"} />

      <div style={{ margin: "auto", marginTop: "5%", maxWidth: 1100 }}>
        <div style={{ display: "flex", alignContent: "center", gridGap: 20 }}>
          <Button
            style={{
              width: 220,
              background: toggle === "document" ? "" : "#ffffff",
            }}
            onClick={() => {
              setToggle("document");
            }}
            children={"เอกสารที่เกี่ยวข้อง"}
          />
          <Button
            style={{
              width: 220,
              background: toggle === "guide" ? "" : "#ffffff",
            }}
            onClick={() => {
              setToggle("guide");
            }}
            children={"แนวทางการตรวจ"}
          />
        </div>

        {toggle === "document" ? (
          <>
            <div className={styles.fontSub}>
              ท่านสามารถคลิกหรือเพิ่มเอกสารที่เห็นว่าเป็นประโยชน์ต่อบุคลากรทางแพทย์ได้ที่นี่
            </div>
            <div className={styles.fontTitle}>
              รายการเอกสารที่เกี่ยวข้องทั้งหมด{" "}
              <span className={styles.fontDate}>(ข้อมูลวันที่ {date})</span>
            </div>
            <div className={styles.align}>
              <Button
                onClick={() => {
                  setOpenModalUploadFile(true);
                }}
                style={{ gridGap: 10 }}
              >
                <img
                  style={{ width: 20, height: 20 }}
                  src={require("../../asset/icon/add-icon.svg").default}
                ></img>
                <div>เพิ่มไฟล์เอกสาร</div>
              </Button>
            </div>

            <div style={{ marginTop: 20 }}>
              <DataTable
                className="classTable"
                columns={columnsDoc}
                data={documentList}
                customStyles={customStyles}
                noDataComponent={
                  <div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>
                }
              />
            </div>

            <Pagination
              page={page}
              totalpage={maxPage}
              clickForward={() => {
                if (page < maxPage) {
                  setPage(page + 1);
                }
              }}
              clickBackward={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
            />
          </>
        ) : null}
        {toggle === "guide" ? (
          <>
            <div className={styles.fontSub}>
              1.ท่านสามารถถ่ายทอดประสบการณ์การรักษาหรือแนวทางการตรวจแก่บุคลากรณ์ทางแพทย์ท่านอื่นๆผ่านทางช่องทางนี้ได้
            </div>
            <div className={styles.fontSub}>
              2.คลิกหัวข้อเพื่ออ่านการถ่ายทอดประสบการณ์จากบุคลากรทางการแพทย์ได้ที่นี่
            </div>
            <div className={styles.fontTitle}>
              แนวทางการตรวจแลป{" "}
              <span className={styles.fontDate}>(ข้อมูลวันที่ {date})</span>
            </div>
            <div className={styles.align}>
              <Button
                onClick={() => {
                  nav("/guidelineTextEditor", {
                    state: {
                      type: "add",
                    },
                  });
                }}
                style={{ gridGap: 10 }}
              >
                <img
                  style={{ width: 20, height: 20 }}
                  src={require("../../asset/icon/add-icon.svg").default}
                ></img>
                <div>เพิ่มข้อมูล</div>
              </Button>
            </div>

            <div style={{ marginTop: 20 }}>
              <DataTable
                className="classTable"
                columns={columnsGuide}
                data={guideList}
                customStyles={customStyles}
                noDataComponent={
                  <div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>
                }
              />
            </div>

            <Pagination
              page={guidePage}
              totalpage={guideMaxPage}
              clickForward={() => {
                if (guidePage < guideMaxPage) {
                  setGuidePage(guidePage + 1);
                }
              }}
              clickBackward={() => {
                if (guidePage > 1) {
                  setGuidePage(guidePage - 1);
                }
              }}
            />
          </>
        ) : null}
      </div>

      <ModalUploadFileV2
        show={openModalUploadFile}
        title={"อัพโหลดไฟล์เอกสาร"}
        placeholder={"ชื่อเอกสาร"}
        titlename={"อัพโหลดไฟล์เอกสาร"}
        onSubmit={addDocument}
        onClose={() => {
          setOpenModalUploadFile(false);
        }}
      />

      {openModalAddData ? (
        <>
          <ModalAddData
            onClose={() => {
              setOpenModalAddData(false);
            }}
            titlename="เพิ่มข้อมูลแนวทางการตรวจ"
            showDetail={showDetail}
            defaultTitle={guidelineTitle}
            defaultDetail={guidelineDetail}
            onSubmit={(e) => {
              if (window.confirm("ยืนยันการบันทึก")) {
                addGuideline(e.title, e.detail);
              }
            }}
          />
        </>
      ) : null}
    </div>
  );
}

export default GuideCheckInspec;
